import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const useSecurityEventEditCondition = () => {
  const currentUser = useCurrentUser();
  return isPermitted(currentUser.permissions, "security_event:edit");
};
export default useSecurityEventEditCondition;
